import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";
import React, { useState, useRef, useEffect } from "react";

type Props = {
  progress: number;
  onSeek?: (progress: number) => void;
};
const numBlock = 10;
const block = [22, 33, 44, 33, 22];
export const AudioProgressBar: React.FC<Props> = ({ progress, onSeek }) => {
  const containerRef = useRef(null);
  const [bars, setBars] = useState<number[]>([]);

  // Generate random heights for the bars once when the component mounts.
  // In a real app, you might pass in actual waveform data.
  useEffect(() => {
    const newBars = [];
    for (let i = 0; i < numBlock; i++) {
      // Generate heights between 30% and 100%
      //newBars.push(Math.random() * 70 + 30);
      newBars.push(...block);
    }
    setBars(newBars);
  }, []);

  // Handle click events to allow seeking
  const handleClick = () => {
    //if (containerRef.current) {
    //  const rect = containerRef.current?.getBoundingClientRect();
    //  const clickX = e.clientX - rect.left;
    //  // Compute new progress (clamped between 0 and 1)
    //  const newProgress = Math.min(Math.max(clickX / rect.width, 0), 1);
    //  if (onSeek) {
    //    onSeek(newProgress);
    //  }
    //}
  };

  return (
    <div
      ref={containerRef}
      onClick={handleClick}
      style={{
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        borderRadius: "8px",
        //padding: "10px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Render the vertical bars */}
      {bars.map((barHeight, index) => (
        <div
          key={index}
          className={css`
            flex: 1;
            background-color: ${index < progress * numBlock * block.length
              ? theme.colors.accent["purple/main"]
              : "#53515C"};
            height: ${barHeight}px;
            border-radius: 2px;
            transition: height 0.3s ease;
            margin: 0 3px;
            @media (max-width: 700px) {
              margin: 0 1px;
            }
          `}
        />
      ))}

      {/* The playhead (current progress marker) */}
      <div
        style={{
          position: "absolute",
          left: `calc(${progress * 100}%)`,
          bottom: 0,
          width: "1px",
          height: "100%",
          backgroundColor: "#FFF",
          transform: "translateX(-50%)",
          borderRadius: "2px",
        }}
      />
    </div>
  );
};
